import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { FormField } from './form-field'
import { FormSubmitButton } from './form-submit-button'
import { FormCheckbox } from './form-checkbox'
import { FormInterface } from 'src/shared/types/entities/form-interface'
import { CommonForm } from 'src/shared/entities/form'
import { FormElementTypeEnum } from 'src/shared/types/entities/form-interface'

export interface FormProps {
  entity: FormInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const Form = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: FormProps) => {
  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonForm entity={entity}>
        {entity.elements.map(element => {
          if (element.elementType === FormElementTypeEnum.Field) {
            return (
              <FormField key={element.id} formEntity={entity} field={element} />
            )
          } else if (element.elementType === FormElementTypeEnum.Checkbox) {
            return (
              <FormCheckbox
                key={element.id}
                formEntity={entity}
                checkbox={element}
              />
            )
          } else {
            return (
              <FormSubmitButton
                key={element.id}
                formEntity={entity}
                submitButton={element}
              />
            )
          }
        })}
      </CommonForm>
    </BaseEntityNew>
  )
}
